module.exports = __webpack_public_path__ + "static/media/trend.46657ab2.jpg";